import { Box, Flex, Link, VStack, Text } from '@chakra-ui/react';
import { StepTitle } from '../step-title';
import { InfoBox } from '../info-box';
import { NumberedStep } from '../numbered-step';
import { CheckItem } from '../check-item';

export const TestConnectionStep: React.FC = () => {
  return (
    <Flex
      direction="column"
      align="center"
      minH="100vh"
      px={6}
      pt={16}
      pb={24}
      bg="white"
      overflowY="auto"
    >
      <VStack gap={5} maxW="500px" w="full">
        <StepTitle stepNumber={2} title="Test Your Kit's Connection To The Internet" />

        {/* Connection Types */}
        <Box
          w="full"
          p={5}
          bg="gray.50"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="flex-start" gap={3}>
            <Text fontSize="sm" color="gray.800">
              Your encoder should have been connected to the internet during the
              first initial setup using either SIM, Ethernet or WiFi. Check for
              any further action required, then test your internet connection:
            </Text>

            <VStack align="flex-start" gap={1} w="full" pt={2}>
              <CheckItem
                icon="check"
                label={<><Text as="span" fontWeight="semibold">SIM</Text>: Card already inserted. No action needed</>}
              />
              <CheckItem
                icon="check"
                label={<><Text as="span" fontWeight="semibold">WiFi</Text>: Details already saved. No action needed</>}
              />
              <CheckItem
                icon="ethernet"
                label={<><Text as="span" fontWeight="semibold">Ethernet</Text>: Plug in the cable</>}
              />
            </VStack>
          </VStack>
        </Box>

        {/* Test Instructions */}
        <Box
          w="full"
          p={5}
          bg="gray.50"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="flex-start" gap={3}>
            <Text fontSize="sm" fontWeight="semibold" color="gray.800">
              Test your internet connection:
            </Text>

            <VStack align="flex-start" gap={1} w="full">
              <NumberedStep number={1}>
                Hold the power button on the encoder for 5 secs to turn on
              </NumberedStep>
              <NumberedStep number={2}>
                Screw on the antennas (2)
              </NumberedStep>
              <NumberedStep number={3}>
                A network icon on the preview screen confirms connection
              </NumberedStep>
              <NumberedStep number={4}>
                Unscrew the antennas. You'll reattach them later
              </NumberedStep>
            </VStack>
          </VStack>
        </Box>

        {/* Info Box */}
        <Box w="full">
          <InfoBox>
            If the network icon doesn't appear, click the following link for a
            guide on{' '}
            <Link
              href="https://frogbox.freshdesk.com/support/solutions/articles/51000510475-how-to-test-your-v2-kit-s-connection-to-the-internet"
              color="green.600"
              fontWeight="semibold"
              textDecoration="underline"
              _hover={{ color: 'green.700' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              how to connect your kit to the internet
            </Link>
            .
          </InfoBox>
        </Box>

        {/* Diagram */}
        <Box w="full" borderRadius="xl" overflow="hidden">
          <img
            src={`${import.meta.env.BASE_URL}images/encoder-setup.webp`}
            alt="Encoder setup instructions"
            style={{ width: '100%', height: 'auto' }}
          />
        </Box>
      </VStack>
    </Flex>
  );
};
